var map = {
	"./bgmofmof.svg": 63924,
	"./c1.svg": 95612,
	"./lizard01.svg": 7606,
	"./lizard02.svg": 96781,
	"./lizard03.svg": 2316,
	"./lizard04.svg": 8085,
	"./lizard05.svg": 92392,
	"./swiper-01.svg": 35545,
	"./swiper-02.svg": 46599,
	"./swiper-03.svg": 4221
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31151;